export const CX_EMAIL_FONT_OPTIONS = ['Arial', 'Roboto', 'Segoe UI', 'Inter'];

export const CX_EMAIL_HEADER_ALIGN_OPTIONS = [
  { value: 'left', label: 'Esquerda' },
  { value: 'center', label: 'Centro' },
  { value: 'right', label: 'Direita' },
];

export const CX_EMAIL_HEADER_SIZE_OPTIONS = [
  { value: 'compact', label: 'Compacto' },
  { value: 'medium', label: 'Médio' },
  { value: 'spacious', label: 'Amplo' },
];

export const CX_EMAIL_HEADER_LOGO_SCALE_STEP = 10;
export const CX_EMAIL_HEADER_LOGO_SCALE_OPTIONS = Array.from(
  { length: 10 },
  (_, i) => (i + 1) * CX_EMAIL_HEADER_LOGO_SCALE_STEP
);

export function normalizeHeaderLogoScale(value) {
  const n = parseInt(value, 10);
  if (!Number.isFinite(n)) return 100;
  const stepped = Math.round(n / CX_EMAIL_HEADER_LOGO_SCALE_STEP) * CX_EMAIL_HEADER_LOGO_SCALE_STEP;
  return Math.max(10, Math.min(100, stepped));
}

export const COMPANY_HEADER_MODE_IMAGE = 'image';
export const COMPANY_HEADER_MODE_TEXT = 'text';

export function normalizeCompanyHeaderModes(raw) {
  if (!raw || typeof raw !== 'object' || Array.isArray(raw)) return {};
  const out = {};
  for (const [key, value] of Object.entries(raw)) {
    const code = String(key ?? '').trim().slice(0, 16);
    if (!code || !/^[A-Za-z0-9_-]+$/.test(code)) continue;
    if (value === COMPANY_HEADER_MODE_TEXT) out[code] = COMPANY_HEADER_MODE_TEXT;
  }
  return out;
}

export function getCompanyHeaderMode(modes, codigo) {
  const code = String(codigo ?? '').trim();
  if (!code) return COMPANY_HEADER_MODE_IMAGE;
  return modes?.[code] === COMPANY_HEADER_MODE_TEXT
    ? COMPANY_HEADER_MODE_TEXT
    : COMPANY_HEADER_MODE_IMAGE;
}

/** Resolve visual do header para uma empresa (envio / pré-visualização). Com logo → imagem; sem logo → nome. */
export function resolveEmpresaHeaderVisual(visual, empresaCodigo, empresaNome, logoViewUrl) {
  const base = visual && typeof visual === 'object' ? visual : {};
  const logoUrl = String(logoViewUrl ?? '').trim();
  if (logoUrl) {
    return {
      ...base,
      headerCompanyName: '',
      logoUrl,
    };
  }
  return {
    ...base,
    headerCompanyName: String(empresaNome ?? '').trim(),
    logoUrl: '',
  };
}

export const CX_EMAIL_PLACEHOLDERS = [
  { key: 'nome', label: 'Nome do cliente' },
  { key: 'empresa', label: 'Nome da empresa' },
  { key: 'tecnico', label: 'Técnico' },
  { key: 'numero_os', label: 'Número da OS' },
  { key: 'equipamento', label: 'Equipamento' },
  { key: 'numero_serie', label: 'Número de série' },
  { key: 'patrimonio', label: 'Patrimônio' },
  { key: 'data_atendimento', label: 'Data do atendimento' },
  { key: 'link_avaliacao', label: 'Link de avaliação' },
];

export const CX_EMAIL_PREVIEW_SAMPLE = {
  nome: 'João Silva',
  empresa: 'Empresa Exemplo Ltda',
  tecnico: 'Carlos Mendes',
  numero_os: 'OS-458921',
  equipamento: 'HP LaserJet Pro M404dn',
  numero_serie: 'SN-8839201847',
  patrimonio: 'PAT-004582',
  data_atendimento: '21/06/2026',
  link_avaliacao: 'https://exemplo.verve.app/avaliar/abc123',
};

export const DEFAULT_CX_EMAIL_TEMPLATE = {
  visual: {
    logoUrl: '',
    logoMode: 'url',
    primaryColor: '#4F46E5',
    secondaryColor: '#818CF8',
    backgroundColor: '#F1F5F9',
    buttonColor: '#4F46E5',
    buttonTextColor: '#FFFFFF',
    fontFamily: 'Segoe UI',
    headerAlign: 'center',
    headerSize: 'medium',
    headerLogoScale: 100,
    companyHeaderModes: {},
    footerLegal: '',
    footerLinks: '',
    footerSignature: '',
    heroImageUrl: '',
    heroImageEnabled: false,
  },
  content: {
    subject: 'Como foi nosso atendimento? Avalie a OS {{numero_os}}',
    greeting: 'Olá, {{nome}}!',
    body:
      'Sua opinião é muito importante para continuarmos melhorando nosso serviço. Reserve um momento para avaliar o atendimento recebido.',
    buttonText: 'Avaliar atendimento',
    thankYou: 'Agradecemos por dedicar um momento para nos avaliar!',
    signature: 'Equipe de Atendimento',
  },
};

export function mergeCxEmailTemplate(raw) {
  const src = raw && typeof raw === 'object' ? raw : {};
  const visualIn = src.visual && typeof src.visual === 'object' ? src.visual : {};
  const contentIn = src.content && typeof src.content === 'object' ? src.content : {};
  const visualPersist = { ...visualIn };
  delete visualPersist.headerCompanyName;
  return {
    visual: {
      ...DEFAULT_CX_EMAIL_TEMPLATE.visual,
      ...visualPersist,
      headerLogoScale: normalizeHeaderLogoScale(
        visualIn.headerLogoScale ?? DEFAULT_CX_EMAIL_TEMPLATE.visual.headerLogoScale
      ),
      companyHeaderModes: normalizeCompanyHeaderModes(visualIn.companyHeaderModes),
    },
    content: { ...DEFAULT_CX_EMAIL_TEMPLATE.content, ...contentIn },
  };
}

export function isDefaultCxEmailTemplate(template) {
  return JSON.stringify(mergeCxEmailTemplate(template)) === JSON.stringify(DEFAULT_CX_EMAIL_TEMPLATE);
}
